import { createSlice } from '@reduxjs/toolkit';

// Config
import { SEEDS_KEYS } from '../../components/Seeds/Seeds';

const initialState = {
  activeSeed: SEEDS_KEYS.tmx,
};

const seedsSlice = createSlice({
  name: 'seeds',
  initialState,
  reducers: {
    setActiveSeed: (state, action) => {
      state.activeSeed = action.payload;
    },
  },
});

export const { setActiveSeed } = seedsSlice.actions;

export default seedsSlice.reducer;
